import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Normalize image shape — DB stores {url, public_id}; legacy was a string. */
export function projectImg(img) {
  if (!img) return undefined;
  const u = typeof img === "string" ? img : img.url;
  return u || undefined;
}

/** Project shape augmented with .cover/.before/.after as strings + image objects retained. */
function normalize(p) {
  return {
    ...p,
    cover: projectImg(p.cover),
    before: projectImg(p.before),
    after: projectImg(p.after),
    gallery: Array.isArray(p.gallery) ? p.gallery.map((g) => projectImg(g)) : [],
    // Keep raw objects too if needed by detail page:
    _cover: p.cover,
    _before: p.before,
    _after: p.after,
    _gallery: p.gallery,
  };
}

let cache = null;
let inflight = null;
let needsRefresh = false;

// Hydration-safe: prerendered pagina's injecteren de build-time projectlijst,
// zodat de eerste client-render identiek is aan de prerendered HTML. De cache
// wordt na mount alsnog ververst zodat nieuwe projecten direct zichtbaar zijn.
if (typeof window !== "undefined" && window.__PRERENDER_STATE__ && window.__PRERENDER_STATE__.projects) {
  cache = window.__PRERENDER_STATE__.projects.map(normalize);
  needsRefresh = true;
}

export function usePublicProjects(service) {
  const [projects, setProjects] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!cache || needsRefresh) {
        if (!inflight) {
          inflight = fetch(`${API}/projects?limit=200`)
            .then((r) => (r.ok ? r.json() : { projects: [] }))
            .then((d) => {
              window.__PC_PROJECTS = d.projects || [];
              cache = (d.projects || []).map(normalize);
              needsRefresh = false;
              return cache;
            })
            .catch(() => (cache = cache || []));
        }
        const data = await inflight;
        if (!cancelled) {
          setProjects(data);
          setLoading(false);
        }
      } else {
        setProjects(cache);
        setLoading(false);
      }
    }
    run();
    return () => { cancelled = true; };
  }, []);

  const filtered = service ? projects.filter((p) => p.service_slug === service) : projects;
  return { projects: filtered, allProjects: projects, loading };
}

/** Invalidate cache — call after admin mutations if needed. */
export function invalidateProjectsCache() {
  cache = null;
  inflight = null;
}
